listTypeProcess=[{
	code:'C',name: 'Tạo phiếu nhập kho mua hàng'
},{
	code:'V',name: 'Xem phiếu nhập kho mua hàng'
},{
	code:'A',name: 'Điều chỉnh phiếu nhập kho mua hàng'
},{
	code:'E',name: 'Hủy phiếu nhập kho mua hàng'
}];

stockTypePR = 1;